export const PROFILE_CLIENT_UPDATE_REQUEST = 'profile/client-update-request'
export const PROFILE_CLIENT_UPDATE_SUCCESS = 'profile/client-success'
export const PROFILE_CLIENT_UPDATE_FAILED = 'profile/client-failed'
